import React from 'react';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';

const CompletedSecUI = (props) => {
    
    return (
        <>
            {/* <span className="w-100"> */}
            <div className="d-flex justify-content-between w-100">
                <p className="mb-0"><i className="fa fa-edit me-2"></i>{props.title}</p>
                {(typeof props.section === "undefined" && props.section !== 'skill')
                    ?
                        props.data.indexOf(props.form_id) !== -1 && (
                            <p className="mb-0"><i className="fa fa-check-circle me-2 com"></i></p>
                        )
                    :
                        (props.data.indexOf(props.form_id[0]) !== -1 || props.data.indexOf(props.form_id[1]) !== -1) && (
                            <p className="mb-0"><i className="fa fa-check-circle me-2 com"></i></p>
                        )
                }
            </div>
            {/* </span> */}
        </>
    );
  }

const SchoolLogoUI = (props) => {
    
    return (
        <a
            href={`/school/${props.data.school_slug}-${props.data.school_id}/${props.data.branch_slug}-${props.data.branch_id}`}
            // target="_blank"
            rel="noopener noreferrer"
        >
            <OverlayTrigger
                placement="bottom"
                overlay={<Tooltip>{props.data.school_name}</Tooltip>}
            >
                    <img src={props.data.school_logo} alt={props.data.school_name} />
            </OverlayTrigger>
        </a>
    );
}

const AccordionSecUI = (props) => {
    return (
        <>
            {/* <span className="w-100"> */}
            <div className="d-flex justify-content-between w-100">
                <p className="mb-0"><i className="fa fa-edit me-2"></i>{props.title}</p>
            </div>
            {/* </span> */}
        </>
    );
}

export {
    CompletedSecUI,
    SchoolLogoUI,
    AccordionSecUI
};